'use client'

import { Builder, withChildren } from '@builder.io/react'

import { Modal } from './Modal'

Builder.registerComponent(withChildren(Modal), {
  name: 'Modal',
  noWrap: true,
  inputs: [
    {
      name: 'children',
      type: 'uiBlocks',
      hideFromUI: true,
    },
    {
      name: 'id',
      type: 'text',
      defaultValue: 'modal-id',
      helperText:
        'Must match the id of a <Modal /> in the page. When the modal is open, the URL hash will be #modal-{id}.',
    },
    {
      name: 'isPreviewing',
      friendlyName: 'Preview Modal',
      type: 'boolean',
      defaultValue: false,
    },
  ],
  defaultChildren: [
    {
      '@type': '@builder.io/sdk:Element',
      component: { name: 'Text', options: { text: 'Content' } },
    },
  ],
  image: 'https://unpkg.com/@tabler/icons@2.44.0/icons/hand-click.svg',
})
